import { RESPONSIBILITY_HISTORY_LIST_ROUTE } from 'config/route-consts';
import React from 'react'
import { Redirect, Route, Switch } from "react-router-dom";
import ResponsibilityHistoryList from './ResponsibilityHistoryList/ResponsibilityHistoryList';

function RoleHistoryView() {
    return (
        <Switch>
            <Route
                key={RESPONSIBILITY_HISTORY_LIST_ROUTE}
                path={RESPONSIBILITY_HISTORY_LIST_ROUTE}
                render={(props: any) => {
                    return <ResponsibilityHistoryList {...props} />;
                }}
            />
            <Redirect to={RESPONSIBILITY_HISTORY_LIST_ROUTE} />
        </Switch>
    );
}

export default RoleHistoryView